import {
  LOAD_USER, LOAD_ROLE, LOAD_MODULE, LOAD_PROJECT, LOAD_QUOTATION, LOAD_QUOTATIONDETAIL, LOAD_CUSTOMER, LOAD_CUSTOMERPURPOSE, LOAD_CUSTOMERAPPROVAL, LOAD_CUSTOMERDECLINE, LOAD_CITIES, LOAD_QUOTATIONUSAGE, LOAD_STATUSCONSTRUCTION, LOAD_STATUS, LOAD_ITEM, LOAD_SPECIFICATIONORIGIN, LOAD_SPECIFICATIONUSAGE, LOAD_ELEVATORUSAGE, LOAD_ELEVATORPANORAMIC, LOAD_ELEVATORMACHINEROOMLOCATION, LOAD_ELEVATORRATEDCAPACITY, LOAD_ELEVATORCAPACITYONCOP, LOAD_ELEVATORRATEDSPEED, LOAD_ELEVATORMAINPOWER, LOAD_ELEVATORTYPE, LOAD_ELEVATORNUMBEROFPERSONS, LOAD_ELEVATORLIGHTINGPOWER, LOAD_ELEVATORFREQUENCY, LOAD_ELEVATOROPERATIONCONTROL, LOAD_ELEVATORHOISTWAYSIZE, LOAD_ELEVATORCARHEIGHTCEILING, LOAD_ELEVATORCARDOOROPENINGTYPE, LOAD_ELEVATORFIRERATING, LOAD_ELEVATORGFLOORMATERIAL, LOAD_ELEVATORTYPFLOORMATERIAL, LOAD_ELEVATORGFLOORJAMBTYPE, LOAD_ELEVATORGFLOORJAMBMATERIAL, LOAD_ELEVATORTOPFLOORHALLCALLBUTTONMATERIAL, LOAD_ELEVATORGFLOORHALLCALLBUTTONMATERIAL, LOAD_ELEVATORTYPICALFLOORHALLCALLBUTTONMATERIAL, LOAD_ELEVATORBOTTOMFLOORHALLCALLBUTTONMATERIAL, LOAD_ELEVATORGFLOORINDICATOR, LOAD_ELEVATORTYPEHALLLANTERN, LOAD_ELEVATORSERVICEFLOORHALLLANTERN, LOAD_ELEVATORWALLFINISHEDTHICKNESS, LOAD_ELEVATORCEILINGTYPE, LOAD_ELEVATORCEILINGDECORATIVECOLOR, LOAD_ELEVATORTRANSOMMATERIAL, LOAD_ELEVATORKICKPLATE, LOAD_ELEVATORCARDOORMATERIAL, LOAD_ELEVATORSAFETYEDGE, LOAD_ELEVATORPVCTYPE, LOAD_ELEVATORMARBLES, LOAD_ELEVATORFLOORPROVIDER, LOAD_ELEVATORHANDRAILTYPE, LOAD_ELEVATORHANDRAILPOSITION, LOAD_ELEVATORSUBOPB, LOAD_ELEVATOROPBTYPE, LOAD_ELEVATOROPBBUTTONTYPE, LOAD_ELEVATORCAROPERATINGPANELMATERIAL, LOAD_ELEVATORINDICATORCAR, LOAD_ELEVATORHANDICAPPEDCOP, LOAD_ELEVATORMAINOPB, LOAD_ELEVATORSUBOPBCAR, LOAD_ELEVATORHANDICAPPEDCOPCAR, LOAD_ELEVATORCARREARWALLSIDEMATERIAL, LOAD_ELEVATORCARREARWALLMIDDLEMATERIAL, LOAD_ELEVATORCARSIDEWALLSIDEMATERIAL, LOAD_ELEVATORCARSIDEWALLMIDDLEMATERIAL, LOAD_ELEVATORCARFRONTWALLMATERIAL, LOAD_ELEVATORCRT, LOAD_ELEVATORHOISTWAYARRANGEMENT, LOAD_ELEVATORHOISTWAYSTRUCTURE, LOAD_ELEVATORRAILBRACKETPITCH, LOAD_ELEVATORCARRAILTYPE, LOAD_ELEVATORCWTRAILTYPE, LOAD_ELEVATORCONTROLPANELLOCATION, LOAD_ELEVATORHOISTWAYDIVIDEDBY, LOAD_DUMBWAITERTYPE, LOAD_DUMBWAITERUSED, LOAD_DUMBWAITERCAPACITY, LOAD_DUMBWAITERSPEED, LOAD_DUMBWAITERSERVICEDFLOOR, LOAD_DUMBWAITERFINISHING, LOAD_DUMBWAITERHOISTWAY, LOAD_MOVINGWALKUSAGE, LOAD_MOVINGWALKMODEL, LOAD_MOVINGWALKTYPE, LOAD_MOVINGWALKBALUSTRADETYPE, LOAD_MOVINGWALKNOMINALWIDTH, LOAD_MOVINGWALKINCLINATIONANGLE, LOAD_MOVINGWALKUSECONDITION, LOAD_MOVINGWALKSPEED, LOAD_MOVINGWALKNATIONALCODE, LOAD_MOVINGWALKPOWERDATAMAINPOWER, LOAD_MOVINGWALKPOWERDATALIGHTINGPOWER, LOAD_MOVINGWALKPOWERDATAFREQUENZY, LOAD_MOVINGWALKARRANGEMENTTYPE, LOAD_MOVINGWALKDRIVEUNIT, LOAD_MOVINGWALKHIGHEFFICIENCYMOTOR, LOAD_MOVINGWALKCONTROLTYPE, LOAD_MOVINGWALKDEGREEOFPROTECTION, LOAD_MOVINGWALKAUXILIARYBRAKE, LOAD_MOVINGWALKTRUSSFINISH, LOAD_MOVINGWALKPALLETCHAINROLLER, LOAD_MOVINGWALKPALLETCHAINTYPEBRAND, LOAD_MOVINGWALKWITHOUTINTERMEDIATESUPPORT, LOAD_MOVINGWALKAUTORUBRICATION, LOAD_MOVINGWALKGLASSJOINTTYPE, LOAD_MOVINGWALKINNEROUTERDECK, LOAD_MOVINGWALKINNEROUTERDECKTHICKNESS, LOAD_MOVINGWALKSKIRTPANEL, LOAD_MOVINGWALKSKIRTPANELTHICKNESS, LOAD_MOVINGWALKSKIRTPANELFINISH, LOAD_MOVINGWALKSKIRTDEFLECTOR, LOAD_MOVINGWALKHANDRAILFRAME, LOAD_MOVINGWALKHANDRAILCOLOR, LOAD_MOVINGWALKHANDRAILMAKER, LOAD_MOVINGWALKPALLETMATERIAL, LOAD_MOVINGWALKPALLETCOLOR, LOAD_MOVINGWALKFLOORPLATE, LOAD_MOVINGWALKFLOORPLATEETCHINGNO, LOAD_MOVINGWALKFLOORMARK, LOAD_MOVINGWALKFLOORPAINTTYPEFACEDIRECTION, LOAD_MOVINGWALKFLOORPAINT, LOAD_MOVINGWALKCOMBFINGER, LOAD_MOVINGWALKHYUNDAILOGO, LOAD_MOVINGWALKCONTROLSTATION, LOAD_MOVINGWALKNEGATIVEPHASEDETECTOR, LOAD_MOVINGWALKOVERLOADRELAY, LOAD_MOVINGWALKUNDEROVERSPEEDSENSOR, LOAD_MOVINGWALKNONREVERSAL, LOAD_MOVINGWALKBROKENSTEPSWITCH, LOAD_MOVINGWALKDISCONNECTSWITCH, LOAD_MOVINGWALKEMERGENCYSTOPSWITCH, LOAD_MOVINGWALKHANDRAILGUARDSWITCH, LOAD_MOVINGWALKCOMBPLATESWITCH, LOAD_MOVINGWALKBROKENSTEPCHAINSWITCH, LOAD_MOVINGWALKFLOORPLATESWITCH, LOAD_MOVINGWALKMOTORCOILOVERHEATINGSENSOR, LOAD_MOVINGWALKDRIVECHAINCOVEROILTRAY, LOAD_MOVINGWALKPALLETSAFETYGUARD, LOAD_MOVINGWALKBRAKEOPENDETECTSWITCH, LOAD_MOVINGWALKHANDRAILSPEEDTEST, LOAD_MOVINGWALKSTEPMISSINGSSWITCH, LOAD_MOVINGWALKFLYWHEELCOVERSWITCH, LOAD_MOVINGWALKFLYWHEELCOVER, LOAD_MOVINGWALKDIRECTIONINDICATOR, LOAD_MOVINGWALKFAULTFINDER, LOAD_MOVINGWALKCABLE, LOAD_MOVINGWALKPROTECTIONFORCABLE, LOAD_MOVINGWALKSTATICOFPREVENTIONDEVICE, LOAD_MOVINGWALKAUTOMATICOPERATION, LOAD_MOVINGWALKINVERTER, LOAD_MOVINGWALKSUPERVISORYPANEL, LOAD_MOVINGWALKSKIRTSWITCH, LOAD_MOVINGWALKNEWELSKIRT, LOAD_MOVINGWALKBROKENMAINDRIVECHAINSWITCH, LOAD_MOVINGWALKPALLETUPTHRUSTSWITCH, LOAD_MOVINGWALKMIDDLEEMERGENCYSTOPSWITCH, LOAD_MOVINGWALKFLOATSWITCH, LOAD_MOVINGWALKUNDERPALLETLIGHTINGLED, LOAD_MOVINGWALKEMERGENCYSTOPCOVERWITHBUZZER, LOAD_MOVINGWALKHEATER, LOAD_MOVINGWALKHANDRAILHEATINGCABLE, LOAD_MOVINGWALKOILWATERSEPARATOR, LOAD_MOVINGWALKPHASEADVANCECAPACITOR, LOAD_MOVINGWALKEXTERIORCLADDING, LOAD_MOVINGWALKMAXWEIGHTOFEXTERIORCLADDING, LOAD_CALCULATOR, LOAD_ELEVATORTOPFLOORHALLCALLBUTTONTYPE, LOAD_ELEVATORGFLOORHALLCALLBUTTONTYPE, LOAD_ELEVATORTYPICALFLOORHALLCALLBUTTONTYPE, LOAD_ELEVATORBOTTOMFLOORHALLCALLBUTTONTYPE, LOAD_ELEVATORHALLCALLBUTTONTYPE,

  //ESCALATOR
  LOAD_ESCALATORUSAGE,
  LOAD_ESCALATORMODEL,
  LOAD_ESCALATORTYPE,
  LOAD_ESCALATORBALUSTRADETYPE,
  LOAD_ESCALATORNOMINALWIDTH,
  LOAD_ESCALATORINCLINATIONANGEL,
  LOAD_ESCALATORUSECONDITION,
  LOAD_ESCALATORSPEED,
  LOAD_ESCALATORHORIZONTALSTEP,
  LOAD_ESCALATORNATIONALCODE,
  LOAD_ESCALATORMAINPOWER,
  LOAD_ESCALATORLIGHTINGPOWER,
  LOAD_ESCALATORFREQUENCY,
  LOAD_ESCALATORARRANGEMENTTYPE,
  LOAD_ESCALATORDRIVEUNIT,
  LOAD_ESCALATORCONTROLTYPE,
  LOAD_ESCALATORDEGREEOFPROTECTION,
  LOAD_ESCALATORTRUSSFINISH,
  LOAD_ESCALATORSTEPCHAINROLLER,
  LOAD_ESCALATORSTEPCHAINTYPE,
  LOAD_ESCALATORWITHOUTINTERMEDIATESUPPORT,
  LOAD_ESCALATORGLASSJOINTYPE,
  LOAD_ESCALATORINNEROUTERDECK,
  LOAD_ESCALATORINNEROUTERDECKTHICKNESS,
  LOAD_ESCALATORNEWELSKIRT,
  LOAD_ESCALATORSKIRTPANEL,
  LOAD_ESCALATORSKIRTPANELTHICKNESS,
  LOAD_ESCALATORSKIRTPANELFINISH,
  LOAD_ESCALATORSKIRTDEFLECTOR,
  LOAD_ESCALATORHANDRAILFRAME,
  LOAD_ESCALATORHANDRAILCOLOR,
  LOAD_ESCALATORHANDRAILMAKER,
  LOAD_ESCALATORSTEPMATERIAL,
  LOAD_ESCALATORSTEPCOLOR,
  LOAD_ESCALATORFLOORPLATE,
  LOAD_ESCALATORFLOORPLATEETCHING,
  LOAD_ESCALATORFLOORMARK,
  LOAD_ESCALATORFLOORPAINT,
  LOAD_ESCALATORCOMBFINGER,
  LOAD_ESCALATORHYUNDAILOGO,
  LOAD_ESCALATORSKIRTLIGHTINGLED,
  LOAD_ESCALATORHANDRAILLIGHTINGLED,
  LOAD_ESCALATORDIRECTIONINDICATOR,
  LOAD_ESCALATORFAULTFINDER,
  LOAD_ESCALATORCABLE,
  LOAD_ESCALATORPROTECTIONCABLE,
  LOAD_ESCALATORAUTOMATICOPERATION,
  LOAD_ESCALATORINVERTER,
  LOAD_ESCALATORSUPERVISORYPANEL,
  LOAD_ESCALATORUNDERSTEPLIGHTINGLED,
  LOAD_ESCALATORCOMBLIGHTINGLED,
  LOAD_ESCALATOREXTERIORCLADDING,
  LOAD_ESCALATORMAXWEIGHTCLADDING,
  LOAD_ESCALATORHIGHEFFICIENCYMOTOR,
  LOAD_ESCALATORAUXILIARYBRAKERISE,
  LOAD_ESCALATORAUTOLUBRICATION,
  LOAD_ESCALATORFLOORPAINTTYPEFACEDIRECTION,
  LOAD_ESCALATORCONTROLSTATION,
  LOAD_ESCALATORNEGATIVEPHASEDETECTOR,
  LOAD_ESCALATOROVERLOADRELAY,
  LOAD_ESCALATORUNDEROVERSPEEDSENSOR,
  LOAD_ESCALATORNONREVERSAL,
  LOAD_ESCALATORBROKENSTEPSWITCH,
  LOAD_ESCALATORDISCONNECTSWITCH,
  LOAD_ESCALATOREMERGENCYSTOPSWITCH,
  LOAD_ESCALATORHANDRAILGUARDSWITCH,
  LOAD_ESCALATORCOMBPLATESWITCH,
  LOAD_ESCALATORBROKENSTEPCHAINSWITCH,
  LOAD_ESCALATORFLOORPLATESWITCH,
  LOAD_ESCALATORMOTORCOILOVERHEATINGSENSOR,
  LOAD_ESCALATORDRIVECHAINCOVEROILTRAYEN115,
  LOAD_ESCALATORSTEPSAFETYGUARDEN115,
  LOAD_ESCALATORBRAKEOPENDETECTSWITCHEN115,
  LOAD_ESCALATORHANDRAILSPEEDTESTEN115,
  LOAD_ESCALATORSTEPMISSINGSWITCHEN115,
  LOAD_ESCALATORFLYWHEELCOVERSWITCHHANDWINDINGDEVICEDETECTIONSWITCHEN115,
  LOAD_ESCALATORFLYWHEELCOVEREN115,
  LOAD_ESCALATORSTATICOFPREVENTIONDEVICEHANDRAILSTEP,
  LOAD_ESCALATORSKIRTSWITCH,
  LOAD_ESCALATORBROKENMAINDRIVECHAINSWITCH,
  LOAD_ESCALATORSTEPUPTHRUSTSWITCH,
  LOAD_ESCALATORMIDDLEEMERGENCYSTOPSWITCH,
  LOAD_ESCALATORFLOATSWITCH,
  LOAD_ESCALATOREMERGENCYSTOPCOVERWITHBUZZER,
  LOAD_ESCALATORHEATER,
  LOAD_ESCALATORHANDRAILHEATINGCABLE,
  LOAD_ESCALATOROILWATERSEPARATOR,
  LOAD_ESCALATORPHASEADVANCECAPACITOR,
  LOAD_ESCALATORDEMARCATION

} from "../actions/types";

const initialState = {
  user: null,
  role: null,
  module: null,
  project: null,
  customer: null,
  customerPurpose: null,
  customerApproval: null,
  customerDec: null,
  cities: null,
  quotationUsage: null,
  statusConstruction: null,
  status: null,
  item: null,
  quotation: null,
  quotationDetail: null,
  origin: null,
  specificationUsage: null,
  elevatorUsage: null,
  elevatorPanoramic: null,
  elevatorMachineRoomLocation: null,
  elevatorRatedCapacity: null,
  elevatorCapacityOnCop: null,
  elevatorRatedSpeed: null,
  elevatorType: null,
  elevatorNumberOfPersons: null,
  elevatorMainPower: null,
  elevatorLightingPower: null,
  elevatorFrequency: null,
  elevatorOperationControl: null,
  elevatorHoistwaySize: null,
  elevatorCarHeightCeiling: null,
  elevatorCarDoorOpeningType: null,
  elevatorFireRating: null,
  elevatorGFloorMaterial: null,
  elevatorTypFloorMaterial: null,
  elevatorGFloorJambType: null,
  elevatorGFloorJambMaterial: null,
  elevatorTopFloorHallCallButtonType: null,
  elevatorTopFloorHallCallButtonMaterial: null,
  elevatorGFloorHallCallButtonType: null,
  elevatorGFloorHallCallButtonMaterial: null,
  elevatorTypicalFloorHallCallButtonMaterial: null,
  elevatorBottomFloorHallCallButtonMaterial: null,
  elevatorGFloorIndicator: null,
  elevatorTypeHallLantern: null,
  elevatorServiceFloorHallLantern: null,
  elevatorWallFinishedThickness: null,
  elevatorCeilingType: null,
  elevatorCeilingDecorativeColor: null,
  elevatorTransomMaterial: null,
  elevatorKickPlate: null,
  elevatorCarDoorMaterial: null,
  elevatorSafetyEdge: null,
  elevatorMarbles: null,
  elevatorFloorProvider: null,
  elevatorHandrailType: null,
  elevatorHandrailPosition: null,
  elevatorSubOpb: null,
  elevatorOpbType: null,
  elevatorOpbButtonType: null,
  elevatorCarOperatingPanelMaterial: null,
  elevatorIndicatorCar: null,
  elevatorHandicappedCop: null,
  elevatorMainOpbCar: null,
  elevatorSubOpbCar: null,
  elevatorHandicappedCopCar: null,
  elevatorCarRearWallSideMaterial: null,
  elevatorCarRearWallMiddleMaterial: null,
  elevatorCarSideWallSideMaterial: null,
  elevatorCarSideWallMiddleMaterial: null,
  elevatorCarFrontWallMaterial: null,
  elevatorCrt: null,
  elevatorHoistwayArrangement: null,
  elevatorHoistwayStructure: null,
  elevatorRailBracketPitch: null,
  elevatorCarRailType: null,
  elevatorCwtRailType: null,
  elevatorControlPanelLocation: null,
  elevatorHoistwayDividedBy: null,

  //escalator
  escalatorUsage: null,
  escalatorModel: null,
  escalatorType: null,
  escalatorBalustradeType: null,
  escalatorNominalWidth: null,
  escalatorInclinationAngel: null,
  escalatorUseCondition: null,
  escalatorSpeed: null,
  escalatorHorizontalStep: null,
  escalatorNationalCode: null,
  escalatorMainPower: null,
  escalatorLightingPower: null,
  escalatorFrequency: null,
  escalatorArrangementType: null,
  escalatorDriveUnit: null,
  escalatorControlType: null,
  escalatorDegreeOfProtection: null,
  escalatorTrussFinish: null,
  escalatorStepChainRoller: null,
  escalatorStepChainType: null,
  escalatorWithoutIntermediateSupport: null,
  escalatorGlassJoinType: null,
  escalatorInnerOuterDeck: null,
  escalatorInnerOuterDeckThickness: null,
  escalatorNewelSkirt: null,
  escalatorSkirtPanel: null,
  escalatorSkirtPanelThickness: null,
  escalatorSkirtPanelFinish: null,
  escalatorSkirtDeflector: null,
  escalatorHandrailFrame: null,
  escalatorHandrailColor: null,
  escalatorHandrailMaker: null,
  escalatorStepMaterial: null,
  escalatorStepColor: null,
  escalatorFloorPlate: null,
  escalatorFloorPlateEtching: null,
  escalatorFloorMark: null,
  escalatorFloorPaint: null,
  escalatorCombfinger: null,
  escalatorHyundaiLogo: null,
  escalatorSkirtLightingLED: null,
  escalatorSkirtHandrailLightingLED: null,
  escalatorDirectionindicator: null,
  escalatorFaultFinder: null,
  escalatorCable: null,
  escalatorProtectionCable: null,
  escalatorAutomaticOperation: null,
  escalatorInverter: null,
  escalatorSupervisoryPanel: null,
  escalatorUnderStepLightingLED: null,
  escalatorCombLightingLED: null,
  escalatorExteriorCladding: null,
  escalatorMaxWeightCladding: null,
  escalatorHighEfficiencyMotor: null,
  escalatorAuxiliaryBrakeRise: null,
  escalatorAutoLubrication: null,
  escalatorFloorPaintTypefaceDirection: null,
  escalatorControlStation: null,
  escalatorNegativePhaseDetector: null,
  escalatorOverLoadRelay: null,
  escalatorUnderOverSpeedSensor: null,
  escalatorNonReversal: null,
  escalatorBrokenStepSwitch: null,
  escalatorDisconnectSwitch: null,
  escalatorEmergencyStopSwitch: null,
  escalatorHandrailGuardSwitch: null,
  escalatorCombPlateSwitch: null,
  escalatorBrokenStepChainSwitch: null,
  escalatorFloorPlateSwitch: null,
  escalatorMotorCoilOverheatingSensor: null,
  escalatorDriveChainCoverOilTray: null,
  escalatorStepSafetyGuard: null,
  escalatorBrakeOpenDetectSwitch: null,
  escalatorHandrailSpeedTest: null,
  escalatorStepMissingSwitch: null,
  escalatorFlywheelCoverSwitchHandWindingDeviceDetectionSwitch: null,
  escalatorFlywheelCover: null,
  escalatorStaticOfPreventionDevice: null,
  escalatorSkirtSwitch: null,
  escalatorBrokenMainDriveChainSwitch: null,
  escalatorStepUpthrustSwitch: null,
  escalatorMiddleEmergencyStopSwitch: null,
  escalatorFloatSwitch: null,
  escalatorEmergencyStopCoverWithBuzzer: null,
  escalatorHeater: null,
  escalatorHandrailHeatingCable: null,
  escalatorOilWaterSeparator: null,
  escalatorPhaseAdvanceCapacitor: null,
  escalatorDemarcation: null,
  dumbwaiterType: null,
  dumbwaiterUsed: null,
  dumbwaiterCapacity: null,
  dumbwaiterSpeed: null,
  dumbwaiterServicedFloor: null,
  dumbwaiterFinishing: null,
  dumbwaiterHoistway: null,
  movingWalkUsage: null,
  movingWalkModel: null,
  movingWalkType: null,
  movingWalkBalustradeType: null,
  movingWalkNominalWidth: null,
  movingWalkInclinationAngle: null,
  movingWalkUseCondition: null,
  movingWalkSpeed: null,
  movingWalkNationalCode: null,
  movingWalkPowerDataMainPower: null,
  movingWalkPowerDataLightingPower: null,
  movingWalkPowerDataFrequenzy: null,
  movingWalkArrangementType: null,
  movingWalkDriveUnit: null,
  movingWalkHighEfficiencyMotor: null,
  movingWalkControlType: null,
  movingWalkDegreeOfProtection: null,
  movingWalkAuxiliaryBrake: null,
  movingWalkTrussFinish: null,
  movingWalkPalletChainRoller: null,
  movingWalkPalletChainTypeBrand: null,
  movingWalkWithoutIntermediateSupport: null,
  movingWalkAutoLubrication: null,
  movingWalkGlassJointType: null,
  movingWalkInnerOuterDeck: null,
  movingWalkInnerOuterDeckThickness: null,
  movingWalkNewelSkirt: null,
  movingWalkSkirtPanel: null,
  movingWalkSkirtPanelThickness: null,
  movingWalkSkirtPanelFinish: null,
  movingWalkSkirtDeflector: null,
  movingWalkHandrailFrame: null,
  movingWalkHandrailColor: null,
  movingWalkHandrailMaker: null,
  movingWalkPalletMaterial: null,
  movingWalkPalletColor: null,
  movingWalkFloorPlate: null,
  movingWalkFloorPlateEtchingNo: null,
  movingWalkFloorMark: null,
  movingWalkFloorPaintTypefaceDirection: null,
  movingWalkFloorPaint: null,
  movingWalkCombfinger: null,
  movingWalkHyundaiLogo: null,
  movingWalkControlStation: null,
  movingWalkNegativePhaseDetector: null,
  movingWalkOverLoadRelay: null,
  movingWalkUnderOverSpeedSensor: null,
  movingWalkNonReversal: null,
  movingWalkBrokenStepSwitch: null,
  movingWalkDisconnectSwitch: null,
  movingWalkEmergencyStopSwitch: null,
  movingWalkHandrailGuardSwitch: null,
  movingWalkCombPlateSwitch: null,
  movingWalkBrokenStepSwitch: null,
  movingWalkFloorPlateSwitch: null,
  movingWalkMotorCoilOverheatingSensor: null,
  movingWalkDriveChainCoverOilTray: null,
  movingWalkPalletSafetyGuard: null,
  movingWalkBrakeOpenDetectSwitch: null,
  movingWalkHandrailSpeedTest: null,
  movingWalkStepMissingsSwitch: null,
  movingWalkFlywheelCoverSwitch: null,
  movingWalkFlywheelCover: null,
  movingWalkDirectionIndicator: null,
  movingWalkFaultFinder: null,
  movingWalkCable: null,
  movingWalkProtectionForCable: null,
  movingWalkStaticOfPreventionDevice: null,
  movingWalkAutomaticOperation: null,
  movingWalkInverter: null,
  movingWalkSupervisoryPanel: null,
  movingWalkSkirtSwitch: null,
  movingWalkBrokenMainDriveChainSwitch: null,
  movingWalkPalletUpthrustSwitch: null,
  movingWalkMiddleEmergencyStopSwitch: null,
  movingWalkFloatSwitch: null,
  movingWalkUnderPalletLightingLED: null,
  movingWalkEmergencyStopCoverWithBuzzer: null,
  movingWalkHeater: null,
  movingWalkHandrailHeatingCable: null,
  movingWalkOilWaterSeparator: null,
  movingWalkPhaseAdvanceCapacitor: null,
  movingWalkExteriorCladding: null,
  movingWalkMaxWeightOfExteriorCladding: null,
  calculator: null,
};

export default function master(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case LOAD_USER:
      return {
        ...state,
        user: payload.data,
      };
    case LOAD_ROLE:
      return {
        ...state,
        role: payload.data,
      };
    case LOAD_MODULE:
      return {
        ...state,
        module: payload.data,
      };
    case LOAD_PROJECT:
      return {
        ...state,
        project: payload.data,
      };
    case LOAD_QUOTATION:
      return {
        ...state,
        quotation: payload.data,
      };
    case LOAD_QUOTATIONDETAIL:
      return {
        ...state,
        quotationDetail: payload.data,
      };
    case LOAD_CUSTOMER:
      return {
        ...state,
        customer: payload.data,
      };
    case LOAD_CUSTOMERPURPOSE:
      return {
        ...state,
        customerPurpose: payload.data,
      };
    case LOAD_CUSTOMERAPPROVAL:
      return {
        ...state,
        customerApproval: payload.data,
      };
    case LOAD_CUSTOMERDECLINE:
      return {
        ...state,
        customerDecline: payload.data,
      };
    case LOAD_CITIES:
      return {
        ...state,
        cities: payload.data,
      };
    case LOAD_QUOTATIONUSAGE:
      return {
        ...state,
        quotationUsage: payload.data,
      };
    case LOAD_STATUSCONSTRUCTION:
      return {
        ...state,
        statusConstruction: payload.data,
      };
    case LOAD_STATUS:
      return {
        ...state,
        status: payload.data,
      };
    case LOAD_ITEM:
      return {
        ...state,
        item: payload.data,
      };
    case LOAD_SPECIFICATIONORIGIN:
      return {
        ...state,
        origin: payload.data,
      };
    case LOAD_SPECIFICATIONUSAGE:
      return {
        ...state,
        specificationUsage: payload.data,
      };
    case LOAD_ELEVATORUSAGE:
      return {
        ...state,
        elevatorUsage: payload.data,
      };
    case LOAD_ELEVATORPANORAMIC:
      return {
        ...state,
        elevatorPanoramic: payload.data,
      };
    case LOAD_ELEVATORMACHINEROOMLOCATION:
      return {
        ...state,
        elevatorMachineRoomLocation: payload.data,
      };
    case LOAD_ELEVATORRATEDCAPACITY:
      return {
        ...state,
        elevatorRatedCapacity: payload.data,
      };
    case LOAD_ELEVATORCAPACITYONCOP:
      return {
        ...state,
        elevatorCapacityOnCop: payload.data,
      };
    case LOAD_ELEVATORRATEDSPEED:
      return {
        ...state,
        elevatorRatedSpeed: payload.data,
      };
    case LOAD_ELEVATORMAINPOWER:
      return {
        ...state,
        elevatorMainPower: payload.data,
      };
    case LOAD_ELEVATORTYPE:
      return {
        ...state,
        elevatorType: payload,
      };
    case LOAD_ELEVATORNUMBEROFPERSONS:
      return {
        ...state,
        elevatorNumberOfPersons: payload.data,
      };
    case LOAD_ELEVATORLIGHTINGPOWER:
      return {
        ...state,
        elevatorLightingPower: payload.data,
      };
    case LOAD_ELEVATORFREQUENCY:
      return {
        ...state,
        elevatorFrequency: payload.data,
      };
    case LOAD_ELEVATOROPERATIONCONTROL:
      return {
        ...state,
        elevatorOperationControl: payload.data,
      };
    case LOAD_ELEVATORHOISTWAYSIZE:
      return {
        ...state,
        elevatorHoistwaySize: payload.data,
      };
    case LOAD_ELEVATORCARHEIGHTCEILING:
      return {
        ...state,
        elevatorCarHeightCeiling: payload.data,
      };
    case LOAD_ELEVATORCARDOOROPENINGTYPE:
      return {
        ...state,
        elevatorCarDoorOpeningType: payload.data,
      };
    case LOAD_ELEVATORFIRERATING:
      return {
        ...state,
        elevatorFireRating: payload.data,
      };
    case LOAD_ELEVATORGFLOORMATERIAL:
      return {
        ...state,
        elevatorGFloorMaterial: payload.data,
      };
    case LOAD_ELEVATORTYPFLOORMATERIAL:
      return {
        ...state,
        elevatorTypFloorMaterial: payload.data,
      };
    case LOAD_ELEVATORGFLOORJAMBTYPE:
      return {
        ...state,
        elevatorGFloorJambType: payload.data,
      };
    case LOAD_ELEVATORGFLOORJAMBMATERIAL:
      return {
        ...state,
        elevatorGFloorJambMaterial: payload.data,
      };
    case LOAD_ELEVATORTOPFLOORHALLCALLBUTTONTYPE:
      return {
        ...state,
        elevatorTopFloorHallCallButtonType: payload.data,
      };
    case LOAD_ELEVATORTOPFLOORHALLCALLBUTTONMATERIAL:
      return {
        ...state,
        elevatorTopFloorHallCallButtonMaterial: payload.data,
      };
    case LOAD_ELEVATORGFLOORHALLCALLBUTTONTYPE:
      return {
        ...state,
        elevatorGFloorHallCallButtonType: payload.data,
      };
    case LOAD_ELEVATORGFLOORHALLCALLBUTTONMATERIAL:
      return {
        ...state,
        elevatorGFloorHallCallButtonMaterial: payload.data,
      };
    case LOAD_ELEVATORBOTTOMFLOORHALLCALLBUTTONTYPE:
      return {
        ...state,
        elevatorBottomFloorHallCallButtonType: payload.data,
      };
    case LOAD_ELEVATORHALLCALLBUTTONTYPE:
      return {
        ...state,
        elevatorHallCallButtonType: payload,
      };
    case LOAD_ELEVATORTYPICALFLOORHALLCALLBUTTONTYPE:
      return {
        ...state,
        elevatorTypicalfloorHallCallButtonType: payload.data,
      };
    case LOAD_ELEVATORTYPICALFLOORHALLCALLBUTTONMATERIAL:
      return {
        ...state,
        elevatorTypicalFloorHallCallButtonMaterial: payload.data,
      };
    case LOAD_ELEVATORBOTTOMFLOORHALLCALLBUTTONMATERIAL:
      return {
        ...state,
        elevatorBottomFloorHallCallButtonMaterial: payload.data,
      };
    case LOAD_ELEVATORGFLOORINDICATOR:
      return {
        ...state,
        elevatorGFloorIndicator: payload.data,
      };
    case LOAD_ELEVATORTYPEHALLLANTERN:
      return {
        ...state,
        elevatorTypeHallLantern: payload.data,
      };
    case LOAD_ELEVATORSERVICEFLOORHALLLANTERN:
      return {
        ...state,
        elevatorServiceFloorHallLantern: payload.data,
      };
    case LOAD_ELEVATORWALLFINISHEDTHICKNESS:
      return {
        ...state,
        elevatorWallFinishedThickness: payload.data,
      };
    case LOAD_ELEVATORCEILINGTYPE:
      return {
        ...state,
        elevatorCeilingType: payload.data,
      };
    case LOAD_ELEVATORCEILINGDECORATIVECOLOR:
      return {
        ...state,
        elevatorCeilingDecorativeColor: payload.data,
      };
    case LOAD_ELEVATORTRANSOMMATERIAL:
      return {
        ...state,
        elevatorTransomMaterial: payload.data,
      };
    case LOAD_ELEVATORKICKPLATE:
      return {
        ...state,
        elevatorKickPlate: payload.data,
      };
    case LOAD_ELEVATORCARDOORMATERIAL:
      return {
        ...state,
        elevatorCarDoorMaterial: payload.data,
      };
    case LOAD_ELEVATORSAFETYEDGE:
      return {
        ...state,
        elevatorSafetyEdge: payload.data,
      };
    case LOAD_ELEVATORPVCTYPE:
      return {
        ...state,
        elevatorPvcType: payload.data,
      };
    case LOAD_ELEVATORMARBLES:
      return {
        ...state,
        elevatorMarbles: payload.data,
      };
    case LOAD_ELEVATORFLOORPROVIDER:
      return {
        ...state,
        elevatorFloorProvider: payload.data,
      };
    case LOAD_ELEVATORHANDRAILTYPE:
      return {
        ...state,
        elevatorHandrailType: payload.data,
      };
    case LOAD_ELEVATORHANDRAILPOSITION:
      return {
        ...state,
        elevatorHandrailPosition: payload.data,
      };
    case LOAD_ELEVATORSUBOPB:
      return {
        ...state,
        elevatorSubOpb: payload,
      };
    case LOAD_ELEVATOROPBTYPE:
      return {
        ...state,
        elevatorOpbType: payload.data,
      };
    case LOAD_ELEVATOROPBBUTTONTYPE:
      return {
        ...state,
        elevatorOpbButtonType: payload.data,
      };
    case LOAD_ELEVATORCAROPERATINGPANELMATERIAL:
      return {
        ...state,
        elevatorCarOperatingPanelMaterial: payload.data,
      };
    case LOAD_ELEVATORINDICATORCAR:
      return {
        ...state,
        elevatorIndicatorCar: payload.data,
      };
    case LOAD_ELEVATORHANDICAPPEDCOP:
      return {
        ...state,
        elevatorHandicappedCop: payload,
      };
    case LOAD_ELEVATORMAINOPB:
      return {
        ...state,
        elevatorMainOpbCar: payload.data,
      };
    case LOAD_ELEVATORSUBOPBCAR:
      return {
        ...state,
        elevatorSubOpbCar: payload.data,
      };
    case LOAD_ELEVATORHANDICAPPEDCOPCAR:
      return {
        ...state,
        elevatorHandicappedCopCar: payload.data,
      };
    case LOAD_ELEVATORCARREARWALLSIDEMATERIAL:
      return {
        ...state,
        elevatorCarRearWallSideMaterial: payload,
      };
    case LOAD_ELEVATORCARREARWALLMIDDLEMATERIAL:
      return {
        ...state,
        elevatorCarRearWallMiddleMaterial: payload.data,
      };
    case LOAD_ELEVATORCARSIDEWALLSIDEMATERIAL:
      return {
        ...state,
        elevatorCarSideWallSideMaterial: payload.data,
      };
    case LOAD_ELEVATORCARSIDEWALLMIDDLEMATERIAL:
      return {
        ...state,
        elevatorCarSideWallMiddleMaterial: payload.data,
      };
    case LOAD_ELEVATORCARFRONTWALLMATERIAL:
      return {
        ...state,
        elevatorCarFrontWallMaterial: payload.data,
      };
    case LOAD_ELEVATORCRT:
      return {
        ...state,
        elevatorCrt: payload.data,
      };
    case LOAD_ELEVATORHOISTWAYARRANGEMENT:
      return {
        ...state,
        elevatorHoistwayArrangement: payload.data,
      };
    case LOAD_ELEVATORHOISTWAYSTRUCTURE:
      return {
        ...state,
        elevatorHoistwayStructure: payload.data,
      };
    case LOAD_ELEVATORRAILBRACKETPITCH:
      return {
        ...state,
        elevatorRailBracketPitch: payload.data,
      };
    case LOAD_ELEVATORCARRAILTYPE:
      return {
        ...state,
        elevatorCarRailType: payload.data,
      };
    case LOAD_ELEVATORCWTRAILTYPE:
      return {
        ...state,
        elevatorCwtRailType: payload.data,
      };
    case LOAD_ELEVATORCONTROLPANELLOCATION:
      return {
        ...state,
        elevatorControlPanelLocation: payload.data,
      };
    case LOAD_ELEVATORHOISTWAYDIVIDEDBY:
      return {
        ...state,
        elevatorHoistwayDividedBy: payload.data,
      };

    //ESCALATOR
    case LOAD_ESCALATORUSAGE:
      return {
        ...state,
        escalatorUsage: payload.data,
      };

    case LOAD_ESCALATORMODEL:
      return {
        ...state,
        escalatorModel: payload.data,
      };

    case LOAD_ESCALATORTYPE:
      return {
        ...state,
        escalatorType: payload.data,
      };

    case LOAD_ESCALATORBALUSTRADETYPE:
      return {
        ...state,
        escalatorBalustradeType: payload.data,
      };

    case LOAD_ESCALATORNOMINALWIDTH:
      return {
        ...state,
        escalatorNominalWidth: payload.data,
      };

    case LOAD_ESCALATORINCLINATIONANGEL:
      return {
        ...state,
        escalatorInclinationAngel: payload.data,
      };

    case LOAD_ESCALATORUSECONDITION:
      return {
        ...state,
        escalatorUseCondition: payload.data,
      };

    case LOAD_ESCALATORSPEED:
      return {
        ...state,
        escalatorSpeed: payload.data,
      };

    case LOAD_ESCALATORHORIZONTALSTEP:
      return {
        ...state,
        escalatorHorizontalStep: payload.data,
      };

    case LOAD_ESCALATORNATIONALCODE:
      return {
        ...state,
        escalatorNationalCode: payload.data,
      };

    case LOAD_ESCALATORMAINPOWER:
      return {
        ...state,
        escalatorMainPower: payload.data,
      };

    case LOAD_ESCALATORLIGHTINGPOWER:
      return {
        ...state,
        escalatorLightingPower: payload.data,
      };

    case LOAD_ESCALATORFREQUENCY:
      return {
        ...state,
        escalatorFrequency: payload.data,
      };

    case LOAD_ESCALATORARRANGEMENTTYPE:
      return {
        ...state,
        escalatorArrangementType: payload.data,
      };

    case LOAD_ESCALATORDRIVEUNIT:
      return {
        ...state,
        escalatorDriveUnit: payload.data,
      };

    case LOAD_ESCALATORCONTROLTYPE:
      return {
        ...state,
        escalatorControlType: payload.data,
      };

    case LOAD_ESCALATORDEGREEOFPROTECTION:
      return {
        ...state,
        escalatorDegreeOfProtection: payload.data,
      };

    case LOAD_ESCALATORTRUSSFINISH:
      return {
        ...state,
        escalatorTrussFinish: payload.data,
      };

    case LOAD_ESCALATORSTEPCHAINROLLER:
      return {
        ...state,
        escalatorStepChainRoller: payload.data,
      };

    case LOAD_ESCALATORSTEPCHAINTYPE:
      return {
        ...state,
        escalatorStepChainType: payload.data,
      };

    case LOAD_ESCALATORWITHOUTINTERMEDIATESUPPORT:
      return {
        ...state,
        escalatorWithoutIntermediateSupport: payload.data,
      };

    case LOAD_ESCALATORGLASSJOINTYPE:
      return {
        ...state,
        escalatorGlassJoinType: payload.data,
      };

    case LOAD_ESCALATORINNEROUTERDECK:
      return {
        ...state,
        escalatorInnerOuterDeck: payload.data,
      };

    case LOAD_ESCALATORINNEROUTERDECKTHICKNESS:
      return {
        ...state,
        escalatorInnerOuterDeckThickness: payload.data,
      };

    case LOAD_ESCALATORNEWELSKIRT:
      return {
        ...state,
        escalatorNewelSkirt: payload.data,
      };

    case LOAD_ESCALATORSKIRTPANEL:
      return {
        ...state,
        escalatorSkirtPanel: payload.data,
      };

    case LOAD_ESCALATORSKIRTPANELTHICKNESS:
      return {
        ...state,
        escalatorSkirtPanelThickness: payload.data,
      };

    case LOAD_ESCALATORSKIRTPANELFINISH:
      return {
        ...state,
        escalatorSkirtPanelFinish: payload.data,
      };

    case LOAD_ESCALATORSKIRTDEFLECTOR:
      return {
        ...state,
        escalatorSkirtDeflector: payload.data,
      };

    case LOAD_ESCALATORHANDRAILFRAME:
      return {
        ...state,
        escalatorHandrailFrame: payload.data,
      };

    case LOAD_ESCALATORHANDRAILCOLOR:
      return {
        ...state,
        escalatorHandrailColor: payload.data,
      };

    case LOAD_ESCALATORHANDRAILMAKER:
      return {
        ...state,
        escalatorHandrailMaker: payload.data,
      };

    case LOAD_ESCALATORSTEPMATERIAL:
      return {
        ...state,
        escalatorStepMaterial: payload.data,
      };

    case LOAD_ESCALATORSTEPCOLOR:
      return {
        ...state,
        escalatorStepColor: payload.data,
      };

    case LOAD_ESCALATORFLOORPLATE:
      return {
        ...state,
        escalatorFloorPlate: payload.data,
      };

    case LOAD_ESCALATORFLOORPLATEETCHING:
      return {
        ...state,
        escalatorFloorPlateEtching: payload.data,
      };

    case LOAD_ESCALATORFLOORMARK:
      return {
        ...state,
        escalatorFloorMark: payload.data,
      };

    case LOAD_ESCALATORFLOORPAINT:
      return {
        ...state,
        escalatorFloorPaint: payload.data,
      };

    case LOAD_ESCALATORCOMBFINGER:
      return {
        ...state,
        escalatorCombfinger: payload.data,
      };

    case LOAD_ESCALATORHYUNDAILOGO:
      return {
        ...state,
        escalatorHyundaiLogo: payload.data,
      };

    case LOAD_ESCALATORSKIRTLIGHTINGLED:
      return {
        ...state,
        escalatorSkirtLightingLED: payload.data,
      };

    case LOAD_ESCALATORHANDRAILLIGHTINGLED:
      return {
        ...state,
        escalatorSkirtHandrailLightingLED: payload.data,
      };

    case LOAD_ESCALATORDIRECTIONINDICATOR:
      return {
        ...state,
        escalatorDirectionindicator: payload.data,
      };

    case LOAD_ESCALATORFAULTFINDER:
      return {
        ...state,
        escalatorFaultFinder: payload.data,
      };

    case LOAD_ESCALATORCABLE:
      return {
        ...state,
        escalatorCable: payload.data,
      };

    case LOAD_ESCALATORPROTECTIONCABLE:
      return {
        ...state,
        escalatorProtectionCable: payload.data,
      };

    case LOAD_ESCALATORAUTOMATICOPERATION:
      return {
        ...state,
        escalatorAutomaticOperation: payload.data,
      };

    case LOAD_ESCALATORINVERTER:
      return {
        ...state,
        escalatorInverter: payload.data,
      };

    case LOAD_ESCALATORSUPERVISORYPANEL:
      return {
        ...state,
        escalatorSupervisoryPanel: payload.data,
      };

    case LOAD_ESCALATORUNDERSTEPLIGHTINGLED:
      return {
        ...state,
        escalatorUnderStepLightingLED: payload.data,
      };

    case LOAD_ESCALATORCOMBLIGHTINGLED:
    // return {
    //   ...state,
    //   escalatorCombLightingLED: payload.data,
    // };

    case LOAD_ESCALATOREXTERIORCLADDING:
      return {
        ...state,
        escalatorExteriorCladding: payload.data,
      };

    case LOAD_ESCALATORMAXWEIGHTCLADDING:
      return {
        ...state,
        escalatorMaxWeightCladding: payload.data,
      };

    case LOAD_ESCALATORHIGHEFFICIENCYMOTOR:
      return {
        ...state,
        escalatorHighEfficiencyMotor: payload.data,
      };

    case LOAD_ESCALATORAUXILIARYBRAKERISE:
      return {
        ...state,
        escalatorAuxiliaryBrakeRise: payload.data,
      };

    case LOAD_ESCALATORAUTOLUBRICATION:
      return {
        ...state,
        escalatorAutoLubrication: payload.data,
      };

    case LOAD_ESCALATORFLOORPAINTTYPEFACEDIRECTION:
      return {
        ...state,
        escalatorFloorPaintTypefaceDirection: payload.data,
      };

    case LOAD_ESCALATORCONTROLSTATION:
      return {
        ...state,
        escalatorControlStation: payload.data,
      };

    case LOAD_ESCALATORNEGATIVEPHASEDETECTOR:
      return {
        ...state,
        escalatorNegativePhaseDetector: payload.data,
      };

    case LOAD_ESCALATOROVERLOADRELAY:
      return {
        ...state,
        escalatorOverLoadRelay: payload.data,
      };

    case LOAD_ESCALATORUNDEROVERSPEEDSENSOR:
      return {
        ...state,
        escalatorUnderOverSpeedSensor: payload.data,
      };

    case LOAD_ESCALATORNONREVERSAL:
      return {
        ...state,
        escalatorNonReversal: payload.data,
      };

    case LOAD_ESCALATORBROKENSTEPSWITCH:
      return {
        ...state,
        escalatorBrokenStepSwitch: payload.data,
      };

    case LOAD_ESCALATORDISCONNECTSWITCH:
      return {
        ...state,
        escalatorDisconnectSwitch: payload.data,
      };

    case LOAD_ESCALATOREMERGENCYSTOPSWITCH:
      return {
        ...state,
        escalatorEmergencyStopSwitch: payload.data,
      };

    case LOAD_ESCALATORHANDRAILGUARDSWITCH:
      return {
        ...state,
        escalatorHandrailGuardSwitch: payload.data,
      };

    case LOAD_ESCALATORCOMBPLATESWITCH:
      return {
        ...state,
        escalatorCombPlateSwitch: payload.data,
      };

    case LOAD_ESCALATORBROKENSTEPCHAINSWITCH:
      return {
        ...state,
        escalatorBrokenStepChainSwitch: payload.data,
      };

    case LOAD_ESCALATORFLOORPLATESWITCH:
      return {
        ...state,
        escalatorFloorPlateSwitch: payload.data,
      };

    case LOAD_ESCALATORMOTORCOILOVERHEATINGSENSOR:
      return {
        ...state,
        escalatorMotorCoilOverheatingSensor: payload.data,
      };

    case LOAD_ESCALATORDRIVECHAINCOVEROILTRAYEN115:
      return {
        ...state,
        escalatorDriveChainCoverOilTray: payload.data,
      };

    case LOAD_ESCALATORSTEPSAFETYGUARDEN115:
      return {
        ...state,
        escalatorStepSafetyGuard: payload.data,
      };

    case LOAD_ESCALATORBRAKEOPENDETECTSWITCHEN115:
      return {
        ...state,
        escalatorBrakeOpenDetectSwitch: payload.data,
      };

    case LOAD_ESCALATORHANDRAILSPEEDTESTEN115:
      return {
        ...state,
        escalatorHandrailSpeedTest: payload.data,
      };

    case LOAD_ESCALATORSTEPMISSINGSWITCHEN115:
      return {
        ...state,
        escalatorStepMissingSwitch: payload.data,
      };

    case LOAD_ESCALATORFLYWHEELCOVERSWITCHHANDWINDINGDEVICEDETECTIONSWITCHEN115:
      return {
        ...state,
        escalatorFlywheelCoverSwitchHandWindingDeviceDetectionSwitch: payload.data,
      };

    case LOAD_ESCALATORFLYWHEELCOVEREN115:
      return {
        ...state,
        escalatorFlywheelCover: payload.data,
      };

    case LOAD_ESCALATORSTATICOFPREVENTIONDEVICEHANDRAILSTEP:
      return {
        ...state,
        escalatorStaticOfPreventionDevice: payload.data,
      };

    case LOAD_ESCALATORSKIRTSWITCH:
      return {
        ...state,
        escalatorSkirtSwitch: payload.data,
      };

    case LOAD_ESCALATORBROKENMAINDRIVECHAINSWITCH:
      return {
        ...state,
        escalatorBrokenMainDriveChainSwitch: payload.data,
      };

    case LOAD_ESCALATORSTEPUPTHRUSTSWITCH:
      return {
        ...state,
        escalatorStepUpthrustSwitch: payload.data,
      };

    case LOAD_ESCALATORMIDDLEEMERGENCYSTOPSWITCH:
      return {
        ...state,
        escalatorMiddleEmergencyStopSwitch: payload.data,
      };

    case LOAD_ESCALATORFLOATSWITCH:
      return {
        ...state,
        escalatorFloatSwitch: payload.data,
      };

    case LOAD_ESCALATOREMERGENCYSTOPCOVERWITHBUZZER:
      return {
        ...state,
        escalatorEmergencyStopCoverWithBuzzer: payload.data,
      };

    case LOAD_ESCALATORHEATER:
      return {
        ...state,
        escalatorHeater: payload.data,
      };

    case LOAD_ESCALATORHANDRAILHEATINGCABLE:
      return {
        ...state,
        escalatorHandrailHeatingCable: payload.data,
      };

    case LOAD_ESCALATOROILWATERSEPARATOR:
      return {
        ...state,
        escalatorOilWaterSeparator: payload.data,
      };

    case LOAD_ESCALATORPHASEADVANCECAPACITOR:
      return {
        ...state,
        escalatorPhaseAdvanceCapacitor: payload.data,
      };

    case LOAD_ESCALATORDEMARCATION:
      return {
        ...state,
        escalatorDemarcation: payload.data,
      };

    case LOAD_DUMBWAITERTYPE:
      return {
        ...state,
        dumbwaiterType: payload.data,
      };
    case LOAD_DUMBWAITERUSED:
      return {
        ...state,
        dumbwaiterUsed: payload.data,
      };
    case LOAD_DUMBWAITERCAPACITY:
      return {
        ...state,
        dumbwaiterCapacity: payload.data,
      };
    case LOAD_DUMBWAITERSPEED:
      return {
        ...state,
        dumbwaiterSpeed: payload.data,
      };
    case LOAD_DUMBWAITERSERVICEDFLOOR:
      return {
        ...state,
        dumbwaiterServicedFloor: payload.data,
      };
    case LOAD_DUMBWAITERFINISHING:
      return {
        ...state,
        dumbwaiterFinishing: payload.data,
      };
    case LOAD_DUMBWAITERHOISTWAY:
      return {
        ...state,
        dumbwaiterHoistway: payload.data,
      };
    case LOAD_MOVINGWALKUSAGE:
      return {
        ...state,
        movingWalkUsage: payload.data,
      };
    case LOAD_MOVINGWALKMODEL:
      return {
        ...state,
        movingWalkModel: payload.data,
      };
    case LOAD_MOVINGWALKTYPE:
      return {
        ...state,
        movingWalkType: payload,
      };
    case LOAD_MOVINGWALKBALUSTRADETYPE:
      return {
        ...state,
        movingWalkBalustradeType: payload,
      };
    case LOAD_MOVINGWALKNOMINALWIDTH:
      return {
        ...state,
        movingWalkNominalWidth: payload.data,
      };
    case LOAD_MOVINGWALKINCLINATIONANGLE:
      return {
        ...state,
        movingWalkInclinationAngle: payload.data,
      };
    case LOAD_MOVINGWALKUSECONDITION:
      return {
        ...state,
        movingWalkUseCondition: payload.data,
      };
    case LOAD_MOVINGWALKSPEED:
      return {
        ...state,
        movingWalkSpeed: payload,
      };
    case LOAD_MOVINGWALKNATIONALCODE:
      return {
        ...state,
        movingWalkNationalCode: payload.data,
      };
    case LOAD_MOVINGWALKPOWERDATAMAINPOWER:
      return {
        ...state,
        movingWalkPowerDataMainPower: payload.data,
      };
    case LOAD_MOVINGWALKPOWERDATALIGHTINGPOWER:
      return {
        ...state,
        movingWalkPowerDataLightingPower: payload.data,
      };
    case LOAD_MOVINGWALKPOWERDATAFREQUENZY:
      return {
        ...state,
        movingWalkPowerDataFrequenzy: payload.data,
      };
    case LOAD_MOVINGWALKARRANGEMENTTYPE:
      return {
        ...state,
        movingWalkArrangementType: payload.data,
      };
    case LOAD_MOVINGWALKDRIVEUNIT:
      return {
        ...state,
        movingWalkDriveUnit: payload.data,
      };
    case LOAD_MOVINGWALKHIGHEFFICIENCYMOTOR:
      return {
        ...state,
        movingWalkHighEfficiencyMotor: payload.data,
      };
    case LOAD_MOVINGWALKCONTROLTYPE:
      return {
        ...state,
        movingWalkControlType: payload.data,
      };
    case LOAD_MOVINGWALKDEGREEOFPROTECTION:
      return {
        ...state,
        movingWalkDegreeOfProtection: payload.data,
      };
    case LOAD_MOVINGWALKAUXILIARYBRAKE:
      return {
        ...state,
        movingWalkAuxiliaryBrake: payload.data,
      };
    case LOAD_MOVINGWALKTRUSSFINISH:
      return {
        ...state,
        movingWalkTrussFinish: payload.data,
      };
    case LOAD_MOVINGWALKPALLETCHAINROLLER:
      return {
        ...state,
        movingWalkPalletChainRoller: payload.data,
      };
    case LOAD_MOVINGWALKPALLETCHAINTYPEBRAND:
      return {
        ...state,
        movingWalkPalletChainTypeBrand: payload.data,
      };
    case LOAD_MOVINGWALKWITHOUTINTERMEDIATESUPPORT:
      return {
        ...state,
        movingWalkWithoutIntermediateSupport: payload,
      };
    case LOAD_MOVINGWALKAUTORUBRICATION:
      return {
        ...state,
        movingWalkAutoLubrication: payload.data,
      };
    case LOAD_MOVINGWALKGLASSJOINTTYPE:
      return {
        ...state,
        movingWalkGlassJointType: payload.data,
      };
    case LOAD_MOVINGWALKINNEROUTERDECK:
      return {
        ...state,
        movingWalkInnerOuterDeck: payload,
      };
    case LOAD_MOVINGWALKINNEROUTERDECKTHICKNESS:
      return {
        ...state,
        movingWalkInnerOuterDeckThickness: payload.data,
      };
    case LOAD_MOVINGWALKNEWELSKIRT:
      return {
        ...state,
        movingWalkNewelSkirt: payload.data,
      };
    case LOAD_MOVINGWALKSKIRTPANEL:
      return {
        ...state,
        movingWalkSkirtPanel: payload,
      };
    case LOAD_MOVINGWALKSKIRTPANELTHICKNESS:
      return {
        ...state,
        movingWalkSkirtPanelThickness: payload.data,
      };
    case LOAD_MOVINGWALKSKIRTPANELFINISH:
      return {
        ...state,
        movingWalkSkirtPanelFinish: payload.data,
      };
    case LOAD_MOVINGWALKSKIRTDEFLECTOR:
      return {
        ...state,
        movingWalkSkirtDeflector: payload.data,
      };
    case LOAD_MOVINGWALKHANDRAILFRAME:
      return {
        ...state,
        movingWalkHandrailFrame: payload.data,
      };
    case LOAD_MOVINGWALKHANDRAILCOLOR:
      return {
        ...state,
        movingWalkHandrailColor: payload.data,
      };
    case LOAD_MOVINGWALKHANDRAILMAKER:
      return {
        ...state,
        movingWalkHandrailMaker: payload.data,
      };
    case LOAD_MOVINGWALKPALLETMATERIAL:
      return {
        ...state,
        movingWalkPalletMaterial: payload.data,
      };
    case LOAD_MOVINGWALKPALLETCOLOR:
      return {
        ...state,
        movingWalkPalletColor: payload.data,
      };
    case LOAD_MOVINGWALKFLOORPLATE:
      return {
        ...state,
        movingWalkFloorPlate: payload,
      };
    case LOAD_MOVINGWALKFLOORPLATEETCHINGNO:
      return {
        ...state,
        movingWalkFloorPlateEtchingNo: payload.data,
      };
    case LOAD_MOVINGWALKFLOORMARK:
      return {
        ...state,
        movingWalkFloorMark: payload.data,
      };
    case LOAD_MOVINGWALKFLOORPAINTTYPEFACEDIRECTION:
      return {
        ...state,
        movingWalkFloorPaintTypefaceDirection: payload.data,
      };
    case LOAD_MOVINGWALKFLOORPAINT:
      return {
        ...state,
        movingWalkFloorPaint: payload,
      };
    case LOAD_MOVINGWALKCOMBFINGER:
      return {
        ...state,
        movingWalkCombfinger: payload.data,
      };
    case LOAD_MOVINGWALKHYUNDAILOGO:
      return {
        ...state,
        movingWalkHyundaiLogo: payload.data,
      };
    case LOAD_MOVINGWALKCONTROLSTATION:
      return {
        ...state,
        movingWalkControlStation: payload.data,
      };
    case LOAD_MOVINGWALKNEGATIVEPHASEDETECTOR:
      return {
        ...state,
        movingWalkNegativePhaseDetector: payload.data,
      };
    case LOAD_MOVINGWALKOVERLOADRELAY:
      return {
        ...state,
        movingWalkOverLoadRelay: payload.data,
      };
    case LOAD_MOVINGWALKUNDEROVERSPEEDSENSOR:
      return {
        ...state,
        movingWalkUnderOverSpeedSensor: payload.data,
      };
    case LOAD_MOVINGWALKNONREVERSAL:
      return {
        ...state,
        movingWalkNonReversal: payload.data,
      };
    case LOAD_MOVINGWALKBROKENSTEPSWITCH:
      return {
        ...state,
        movingWalkBrokenStepSwitch: payload.data,
      };
    case LOAD_MOVINGWALKDISCONNECTSWITCH:
      return {
        ...state,
        movingWalkDisconnectSwitch: payload.data,
      };
    case LOAD_MOVINGWALKEMERGENCYSTOPSWITCH:
      return {
        ...state,
        movingWalkEmergencyStopSwitch: payload.data,
      };
    case LOAD_MOVINGWALKHANDRAILGUARDSWITCH:
      return {
        ...state,
        movingWalkHandrailGuardSwitch: payload.data,
      };
    case LOAD_MOVINGWALKCOMBPLATESWITCH:
      return {
        ...state,
        movingWalkCombPlateSwitch: payload.data,
      };
    case LOAD_MOVINGWALKBROKENSTEPCHAINSWITCH:
      return {
        ...state,
        movingWalkBrokenStepChainSwitch: payload.data,
      };
    case LOAD_MOVINGWALKFLOORPLATESWITCH:
      return {
        ...state,
        movingWalkFloorPlateSwitch: payload.data,
      };
    case LOAD_MOVINGWALKMOTORCOILOVERHEATINGSENSOR:
      return {
        ...state,
        movingWalkMotorCoilOverheatingSensor: payload.data,
      };
    case LOAD_MOVINGWALKDRIVECHAINCOVEROILTRAY:
      return {
        ...state,
        movingWalkDriveChainCoverOilTray: payload.data,
      };
    case LOAD_MOVINGWALKPALLETSAFETYGUARD:
      return {
        ...state,
        movingWalkPalletSafetyGuard: payload.data,
      };
    case LOAD_MOVINGWALKBRAKEOPENDETECTSWITCH:
      return {
        ...state,
        movingWalkBrakeOpenDetectSwitch: payload.data,
      };
    case LOAD_MOVINGWALKHANDRAILSPEEDTEST:
      return {
        ...state,
        movingWalkHandrailSpeedTest: payload.data,
      };
    case LOAD_MOVINGWALKSTEPMISSINGSSWITCH:
      return {
        ...state,
        movingWalkHandrailSpeedTest: payload.data,
      };
    case LOAD_MOVINGWALKFLYWHEELCOVERSWITCH:
      return {
        ...state,
        movingWalkFlywheelCoverSwitch: payload.data,
      };
    case LOAD_MOVINGWALKFLYWHEELCOVER:
      return {
        ...state,
        movingWalkFlywheelCover: payload.data,
      };
    case LOAD_MOVINGWALKDIRECTIONINDICATOR:
      return {
        ...state,
        movingWalkDirectionIndicator: payload.data,
      };
    case LOAD_MOVINGWALKFAULTFINDER:
      return {
        ...state,
        movingWalkFaultFinder: payload.data,
      };
    case LOAD_MOVINGWALKCABLE:
      return {
        ...state,
        movingWalkCable: payload,
      };
    case LOAD_MOVINGWALKPROTECTIONFORCABLE:
      return {
        ...state,
        movingWalkProtectionForCable: payload.data,
      };
    case LOAD_MOVINGWALKSTATICOFPREVENTIONDEVICE:
      return {
        ...state,
        movingWalkStaticOfPreventionDevice: payload.data,
      };
    case LOAD_MOVINGWALKAUTOMATICOPERATION:
      return {
        ...state,
        movingWalkAutomaticOperation: payload.data,
      };
    case LOAD_MOVINGWALKINVERTER:
      return {
        ...state,
        movingWalkInverter: payload,
      };
    case LOAD_MOVINGWALKSUPERVISORYPANEL:
      return {
        ...state,
        movingWalkSupervisoryPanel: payload.data,
      };
    case LOAD_MOVINGWALKSKIRTSWITCH:
      return {
        ...state,
        movingWalkSkirtSwitch: payload.data,
      };
    case LOAD_MOVINGWALKBROKENMAINDRIVECHAINSWITCH:
      return {
        ...state,
        movingWalkBrokenMainDriveChainSwitch: payload.data,
      };
    case LOAD_MOVINGWALKPALLETUPTHRUSTSWITCH:
      return {
        ...state,
        movingWalkPalletUpthrustSwitch: payload.data,
      };
    case LOAD_MOVINGWALKMIDDLEEMERGENCYSTOPSWITCH:
      return {
        ...state,
        movingWalkMiddleEmergencyStopSwitch: payload.data,
      };
    case LOAD_MOVINGWALKFLOATSWITCH:
      return {
        ...state,
        movingWalkFloatSwitch: payload.data,
      };
    case LOAD_MOVINGWALKUNDERPALLETLIGHTINGLED:
      return {
        ...state,
        movingWalkUnderPalletLightingLED: payload.data,
      };
    case LOAD_MOVINGWALKEMERGENCYSTOPCOVERWITHBUZZER:
      return {
        ...state,
        movingWalkEmergencyStopCoverWithBuzzer: payload.data,
      };
    case LOAD_MOVINGWALKHEATER:
      return {
        ...state,
        movingWalkHeater: payload.data,
      };
    case LOAD_MOVINGWALKHANDRAILHEATINGCABLE:
      return {
        ...state,
        movingWalkHandrailHeatingCable: payload.data,
      };
    case LOAD_MOVINGWALKOILWATERSEPARATOR:
      return {
        ...state,
        movingWalkOilWaterSeparator: payload.data,
      };
    case LOAD_MOVINGWALKPHASEADVANCECAPACITOR:
      return {
        ...state,
        movingWalkPhaseAdvanceCapacitor: payload.data,
      };
    case LOAD_MOVINGWALKEXTERIORCLADDING:
      return {
        ...state,
        movingWalkExteriorCladding: payload,
      };
    case LOAD_MOVINGWALKMAXWEIGHTOFEXTERIORCLADDING:
      return {
        ...state,
        movingWalkMaxWeightOfExteriorCladding: payload.data,
      };
    case LOAD_CALCULATOR:
      return {
        ...state,
        calculator: payload.data,
      };
    default:
      return state;
  }
}